import { css } from 'styled-components'
import { minMq } from '../../shared/styles/breakPoints'
import variables from '../../shared/styles/variables'

const header = (category: "toyama" | "niigata") => {
  const bgColor = category === "toyama" ? variables.LIGHT_BLUE : variables.SEAGREEN

  return css`
    background-color: ${bgColor};
    color: ${variables.WHITE};
    display: inline-block;
    font-size: 3rem;
    font-weight: 500;
    line-height: 48px;
    margin-bottom: 60px;
    margin-top: 40px;
    padding-left: 7px;
    padding-right: 9px;

    ${minMq('MD')} {
      font-size: 5.6rem;
      line-height: 84px;
      margin-bottom: 80px;
      margin-top: 70px;
      padding-left: 14px;
      padding-right: 18px;
    }
  `
}

export const style = {
  header,
}